import Vue from 'vue'
import VueRouter from 'vue-router'
import jinjiang from '../views/jinjiang/routes'
import chongzhou from '../views/chongzhou/routes'
import wuhou from '../views/wuhou/routes'
import dayi from '../views/dayi/routes'
import qingyang from '../views/qingyang/routes'
import qingbaijiang from '../views/qingbaijiang/routes'

Vue.use(VueRouter)

const baseRoutes = [
  {
    path: '/oneKnow',
    name: 'oneKnow',
    meta: {
      title: '功能指南一图看懂'
    },
    component: () => import('../views/oneKnow.vue')
  },
  {
    path: '/normal',
    name: 'normal',
    meta: {
      title: '常见用法'
    },
    component: () => import('../views/normal.vue')
  },
  {
    path: '/5',
    name: '1',
    meta: {
      title: '学历人才落户'
    },
    component: () => import('../views/xlrclh.vue')
  },
  {
    path: '/3',
    name: '2',
    meta: {
      title: '专业技术人才落户'
    },
    component: () => import('../views/zyjsrclh.vue')
  },
  {
    path: '/4',
    name: '3',
    meta: {
      title: '技能人才落户'
    },
    component: () => import('../views/jnrclh.vue')
  },
  {
    path: '/7',
    name: '4',
    meta: {
      title: '人才公寓预申请'
    },
    component: () => import('../views/rcgyysq.vue')
  },
  {
    path: '/8',
    name: '5',
    meta: {
      title: '人才公寓申请'
    },
    component: () => import('../views/rcgysq.vue')
  },
  {
    path: '/6',
    name: '6',
    meta: {
      title: '“蓉漂”青年人才驿站'
    },
    component: () => import('../views/rpqnrcyz.vue')
  },
  {
    path: '/1',
    name: '7',
    meta: {
      title: '蓉城人才绿卡'
    },
    component: () => import('../views/rcrclc.vue')
  },
  {
    path: '/2',
    name: '8',
    meta: {
      title: '急需紧缺人才专属礼包'
    },
    component: () => import('../views/jxqrczslb.vue')
  },
  {
    path: '/9',
    name: '9',
    meta: {
      title: '“蓉漂”计划'
    },
    component: () => import('../views/rpjh.vue')
  },
  {
    path: '/10',
    name: '10',
    meta: {
      title: '产业建圈强链人才计划'
    },
    component: () => import('../views/10.vue')
  },
  {
    // 成都工匠
    path: '/11',
    name: '11',
    meta: {
      title: '成都工匠培育计划'
    },
    component: () => import('../views/craftsman.vue')
  },
  {
    // 人才贷
    path: '/14',
    name: '12',
    meta: {
      title: '人才贷、成果贷、研发贷'
    },
    component: () => import('../views/loans.vue')
  },
  {
    // 创新创业资助
    path: '/13',
    name: '13',
    meta: {
      title: '青年创客创新创业资助'
    },
    component: () => import('../views/entrepreneurship.vue')
  },
  {
    // 紧缺专业安家补贴
    path: '/25',
    name: '14',
    meta: {
      title: '急需紧缺专业技术人才安家补贴'
    },
    component: () => import('../views/Relocationallowance.vue')
  },
  {
    // 紧缺技能安家补贴
    path: '/17',
    name: '15',
    meta: {
      title: '急需紧缺技能人才安家补贴'
    },
    component: () => import('../views/15.vue')
  },
  {
    // 专业技术补贴
    path: '/20',
    name: '16',
    meta: {
      title: '专业技术职称提升补贴'
    },
    component: () => import('../views/16.vue')
  },
  {
    // 专业技术补贴
    path: '/21',
    name: '17',
    meta: {
      title: '技能提升奖励'
    },
    component: () => import('../views/17.vue')
  },
  {
    // 专业技术补贴
    path: '/19',
    name: '18',
    meta: {
      title: '人才贡献激励'
    },
    component: () => import('../views/18.vue')
  },

  {
    path: '/24',
    name: '20',
    meta: {
      title: '博士后人才生活资助及项目资助'
    },
    component: () => import('../views/20.vue')
  },
  // 21没有

  {
    // 专业技术补贴
    path: '/23',
    name: '22',
    meta: {
      title: '新引进应届博士生活补贴'
    },
    component: () => import('../views/22.vue')
  },
  {
    // 专业技术补贴
    path: '/15',
    name: '23',
    meta: {
      title: '优秀海外高校应届毕业生创新创业补贴'
    },
    component: () => import('../views/23.vue')
  },
  {
    // 专业技术补贴
    path: '/18',
    name: '24',
    meta: {
      title: '高校毕业生在蓉灵活缴存住房公积金'
    },
    component: () => import('../views/24.vue')
  },
  {
    path: '/16',
    name: '21',
    meta: {
      title: '应届硕士研究生生活补贴'
    },
    component: () => import('../views/21.vue')
  },
  // 19没有
  {
    path: '/22',
    name: '19',
    meta: {
      title: '双招双引'
    },
    component: () => import('../views/19.vue')
  },
  {
    path: '/26',
    name: 'c26',
    meta: {
      title: '保障性租赁住房申请'
    },
    component: () => import('../views/c26.vue')
  },
  {
    path: '/27',
    name: 'c27',
    meta: {
      title: '蓉城英才计划'
    },
    component: () => import('../views/c27.vue')
  },
  // 青羊区的政策
  {
    path: '/50',
    name: '50',
    meta: {
      title: '青羊区引进创新创业人才'
    },
    component: () => import('../views/50.vue')
  },
  // 武侯区
  {
    path: '/51',
    name: '51',
    meta: {
      title: '成都市武侯区“诸葛工匠”'
    },
    component: () => import('../views/51.vue')
  },
  //成华区
  {
    path: '/52',
    name: '52',
    meta: {
      title: '“成华工匠”政策解读”'
    },
    component: () => import('../views/52.vue')
  },
  {
    path: '/53',
    name: '53',
    meta: {
      title: '成华区“技能大师工作室”'
    },
    component: () => import('../views/53.vue')
  },
  // 青白江
  {
    path: '/54',
    name: '54',
    meta: {
      title: '青白江区人才落户专项奖励政策解读'
    },
    component: () => import('../views/54.vue')
  },
  // 龙泉
  {
    path: '/55',
    name: '55',
    meta: {
      title: '“龙泉驿英才计划”'
    },
    component: () => import('../views/55.vue')
  },
  // 郫都区
  {
    path: '/56',
    name: '56',
    meta: {
      title: '郫都区社会工作人才扶持激励办法解读'
    },
    component: () => import('../views/56.vue')
  },
  {
    path: '/57',
    name: '57',
    meta: {
      title: '郫都区有突出贡献的优秀专家人才'
    },
    component: () => import('../views/57.vue')
  },
  {
    path: '/63',
    name: '63',
    meta: {
      title: '“郫都菁英百人培养计划”实施办法解读'
    },
    component: () => import('../views/63.vue')
  },
  // 金堂
  {
    path: '/58',
    name: '58',
    meta: {
      title: '金堂工匠'
    },
    component: () => import('../views/58.vue')
  },
  // 彭州
  {
    path: '/59',
    name: '59',
    meta: {
      title: '彭州企业引进产业菁英人才激励'
    },
    component: () => import('../views/59.vue')
  },
  {
    path: '/60',
    name: '60',
    meta: {
      title: '“天彭菁英绿卡”'
    },
    component: () => import('../views/60.vue')
  },
  {
    path: '/61',
    name: '61',
    meta: {
      title: '彭州工匠政策解读'
    },
    component: () => import('../views/61.vue')
  },
  // 新都
  {
    path: '/62',
    name: '62',
    meta: {
      title: '新都区支持高校大学生来发展政策解读'
    },
    component: () => import('../views/62.vue')
  },
  // 崇州
  {
    path: '/64',
    name: '64',
    meta: {
      title: '“蓉城人才绿卡（崇州卡）”政策解读'
    },
    component: () => import('../views/64.vue')
  },
  {
    path: '/65',
    name: '65',
    meta: {
      title: '崇州市“蜀城英才计划”优秀人才'
    },
    component: () => import('../views/65.vue')
  },
  {
    path: '/66',
    name: '66',
    meta: {
      title: '崇州市急需紧缺人才引育服务政策解读'
    },
    component: () => import('../views/66.vue')
  },
  {
    path: '/67',
    name: '67',
    meta: {
      title: '崇州市有突出贡献的拔尖人才'
    },
    component: () => import('../views/67.vue')
  },
  // 天府新区
  {
    path: '/68',
    name: '68',
    meta: {
      title: '“天府英才计划”政策解读'
    },
    component: () => import('../views/68.vue')
  },
  {
    path: '/applyPolicy/:id',
    name: 'applyPolicy',
    meta: {
      title: '人才申报政策解读'
    },
    component: () => import('../views/applyPolicy.vue')
  },
  //新津
  {
    path: '/69',
    name: '69',
    meta: {
      title: '彭州市人才购房补贴'
    },
    component: () => import('../views/69.vue')
  },
  //锦江区
  {
    path: '/70',
    name: '70',
    meta: {
      title: '锦江区关于企业高管团队专项奖励'
    },
    component: () => import('../views/70.vue')
  },
  {
    path: '/71',
    name: '71',
    meta: {
      title: '锦江区关于支持产学研联合培养人才'
    },
    component: () => import('../views/71.vue')
  },
  {
    path: '/72',
    name: '72',
    meta: {
      title: '锦江区关于支持企业自主引才'
    },
    component: () => import('../views/72.vue')
  },
  {
    path: '/73',
    name: '73',
    meta: {
      title: '锦江区关于支持企业自主育才'
    },
    component: () => import('../views/73.vue')
  },
  {
    path: '/74',
    name: '74',
    meta: {
      title: '锦江区关于关于支持中介机构引才育才'
    },
    component: () => import('../views/74.vue')
  },
  {
    path: '/75',
    name: '75',
    meta: {
      title: '锦江区关于中高端产业人才专项补贴'
    },
    component: () => import('../views/75.vue')
  },

  //都江堰
  {
    path: '/76',
    name: '76',
    meta: {
      title: '都江堰市扶持高层次人才创新创业'
    },
    component: () => import('../views/76.vue')
  },
  {
    path: '/77',
    name: '77',
    meta: {
      title: '都江堰市企业新引进正、副高级职称人才待遇'
    },
    component: () => import('../views/77.vue')
  },
  //双流区
  {
    path: '/78',
    name: '78',
    meta: {
      title: '双流区“悦航都”人才服务政策解读'
    },
    component: () => import('../views/78.vue')
  },
  {
    path: '/79',
    name: '79',
    meta: {
      title: '双流区人才安家补贴'
    },
    component: () => import('../views/79.vue')
  },
  {
    path: '/80',
    name: '80',
    meta: {
      title: '双流区属地人才贡献奖'
    },
    component: () => import('../views/80.vue')
  },
  {
    path: '/81',
    name: '81',
    meta: {
      title: '双流区高技能人才补贴'
    },
    component: () => import('../views/81.vue')
  },
  {
    path: '/82',
    name: '82',
    meta: {
      title: '双流区高技能人才招引奖励'
    },
    component: () => import('../views/82.vue')
  },
  {
    path: '/83',
    name: '83',
    meta: {
      title: '双流区顶尖技能人才服务保障支持政策解读'
    },
    component: () => import('../views/83.vue')
  },
  //大邑县
  {
    path: '/84',
    name: '84',
    meta: {
      title: '“大邑工匠”政策解读'
    },
    component: () => import('../views/84.vue')
  },
  {
    path: '/85',
    name: '85',
    meta: {
      title: '大邑县“首席医疗专家计划”'
    },
    component: () => import('../views/85.vue')
  },
  {
    path: '/86',
    name: '86',
    meta: {
      title: '大邑县“首席名师计划”政策解读'
    },
    component: () => import('../views/86.vue')
  },
  {
    path: '/87',
    name: '87',
    meta: {
      title: '大邑县“社区能人”'
    },
    component: () => import('../views/87.vue')
  },
  {
    path: '/88',
    name: '88',
    meta: {
      title: '大邑县“技能大师”政策解读'
    },
    component: () => import('../views/88.vue')
  },
  {
    path: '/89',
    name: '89',
    meta: {
      title: '《成都高新区急需科技创新领军人才》'
    },
    component: () => import('../views/89.vue')
  },
  {
    path: '/90',
    name: '90',
    meta: {
      title: '创新创业支持'
    },
    component: () => import('../views/90.vue')
  },
  {
    path: '/91',
    name: '91',
    meta: {
      title: '综合服务保障'
    },
    component: () => import('../views/91.vue')
  },
  {
    path: '/92',
    name: '92',
    meta: {
      title: '职业发展支持'
    },
    component: () => import('../views/92.vue')
  },
  {
    path: '/93',
    name: '93',
    meta: {
      title: '项目支持'
    },
    component: () => import('../views/93.vue')
  },

  {
    path: '/94',
    name: '94',
    meta: {
      title: '金牛区“骄子专项”体育竞技领域'
    },
    component: () => import('../views/94.vue')
  },
  {
    path: '/95',
    name: '95',
    meta: {
      title: '金牛区“骄子伯乐”奖励'
    },
    component: () => import('../views/95.vue')
  },
  {
    path: '/96',
    name: '96',
    meta: {
      title: '金牛区关于支持校地协同创新'
    },
    component: () => import('../views/96.vue')
  },
  {
    path: '/97',
    name: '97',
    meta: {
      title: '金牛区企业自主认定举荐人才'
    },
    component: () => import('../views/97.vue')
  },
  {
    path: '/98',
    name: '98',
    meta: {
      title: '金牛区青年人才引进培育'
    },
    component: () => import('../views/98.vue')
  },
  {
    path: '/99',
    name: '99',
    meta: {
      title: '金牛区教育人才激励政策'
    },
    component: () => import('../views/99.vue')
  },
  {
    path: '/100',
    name: '100',
    meta: {
      title: '金牛区关于促进优秀卫生健康人才发展'
    },
    component: () => import('../views/100.vue')
  },
  {
    path: '/101',
    name: '101',
    meta: {
      title: '金牛区技术技能菁英人才奖励'
    },
    component: () => import('../views/101.vue')
  },
  {
    path: '/102',
    name: '102',
    meta: {
      title: '骄子引才工作站实施细则解读'
    },
    component: () => import('../views/102.vue')
  },
  {
    path: '/103',
    name: '103',
    meta: {
      title: '支持设立新工科实训平台实施细则解读'
    },
    component: () => import('../views/103.vue')
  },
  {
    path: '/104',
    name: '104',
    meta: {
      title: '急需紧缺人才和高端人才认定办法解读'
    },
    component: () => import('../views/104.vue')
  },
  {
    path: '/105',
    name: '105',
    meta: {
      title: '"骄子计划"实施细则解读'
    },
    component: () => import('../views/105.vue')
  },
  {
    path: '/106',
    name: '106',
    meta: {
      title: '"骄子专项"服装服饰时尚设计领域实施细则解读'
    },
    component: () => import('../views/106.vue')
  },
  {
    path: '/107',
    name: '107',
    meta: {
      title: '"骄子专项"电商直播领域实施细则解读'
    },
    component: () => import('../views/107.vue')
  },
  {
    path: '/108',
    name: '108',
    meta: {
      title: '"骄子专项"文化创意领域实施细则解读'
    },
    component: () => import('../views/108.vue')
  },
  {
    path: '/109',
    name: '109',
    meta: {
      title: '关于加强大院大所人才引育服务工作的若干措施(试行)'
    },
    component: () => import('../views/109.vue')
  },
  {
    path: '/110',
    name: '110',
    meta: {
      title: '新津区去引进培育“津英人才”若干政策2.0'
    },
    component: () => import('../views/110.vue')
  },
  {
    path: '/111',
    name: '111',
    meta: {
      title: '新津区支持数字经济青年人才发展十条'
    },
    component: () => import('../views/111.vue')
  },

  {
    path: '/112',
    name: '112',
    meta: {
      title: '简阳工匠'
    },
    component: () => import('../views/112.vue')
  },
  {
    path: '/113',
    name: '113',
    meta: {
      title: '邛州爱才行动'
    },
    component: () => import('../views/113.vue')
  },
  {
    path: '/114',
    name: '114',
    meta: {
      title: '金堂县“社工人才”政策支持'
    },
    component: () => import('../views/114.vue')
  },
  {
    path: '/115',
    name: '115',
    meta: {
      title: '金堂县支持大学生就业政策解读'
    },
    component: () => import('../views/115.vue')
  },
  {
    path: '/116',
    name: '116',
    meta: {
      title: '龙泉驿引进研究生学历学位应届毕业生奖励政策解读'
    },
    component: () => import('../views/116.vue')
  },
  {
    path: '/117',
    name: '117',
    meta: {
      title: '龙泉驿博士后资助政策解读'
    },
    component: () => import('../views/117.vue')
  },
  {
    path: '/118',
    name: '118',
    meta: {
      title: '龙泉驿博士后资助政策解读'
    },
    component: () => import('../views/117.vue')
  },
  {
    path: '/119',
    name: '119',
    meta: {
      title: '龙泉驿博士后资助政策解读'
    },
    component: () => import('../views/117.vue')
  },
  {
    path: '/120',
    name: '120',
    meta: {
      title: '龙泉驿博士后资助政策解读'
    },
    component: () => import('../views/117.vue')
  },
  {
    path: '/121',
    name: '121',
    meta: {
      title: '新津区技能大师工作室政策解读'
    },
    component: () => import('../views/121.vue')
  },
  {
    path: '/122',
    name: '122',
    meta: {
      title: '新津区新津工匠政策解读'
    },
    component: () => import('../views/122.vue')
  },
  {
    path: '/123',
    name: '123',
    meta: {
      title: '《成都市新津区“津津希望”选培计划实施方案》解读'
    },
    component: () => import('../views/123.vue')
  },
  {
    path: '/124',
    name: '124',
    meta: {
      title: '成都市新津区引进培育津英教育人才实施办法'
    },
    component: () => import('../views/124.vue')
  },
  {
    path: '/125',
    name: '125',
    meta: {
      title: '《成都市新津区引进培育津英卫生人才实施办法》'
    },
    component: () => import('../views/125.vue')
  },
  {
    path: '/126',
    name: '126',
    meta: {
      title: '运动员、裁判员来蓉入户政策'
    },
    component: () => import('../views/126.vue')
  },
  {
    path: '/127',
    name: '127',
    meta: {
      title: '大型综合性运动会竞赛成绩奖励'
    },
    component: () => import('../views/127.vue')
  },
  {
    path: '/128',
    name: '128',
    meta: {
      title: '专业技术职务任职资格初定'
    },
    component: () => import('../views/128.vue')
  },
  {
    path: '/129',
    name: '129',
    meta: {
      title: '职业技能竞赛奖励政策'
    },
    component: () => import('../views/129.vue')
  },
  {
    path: '/130',
    name: '130',
    meta: {
      title: '购买商品住房支持'
    },
    component: () => import('../views/130.vue')
  },
  {
    path: '/131',
    name: '131',
    meta: {
      title: '博士研究生安家生活补贴'
    },
    component: () => import('../views/131.vue')
  },
  {
    path: '/132',
    name: '132',
    meta: {
      title: '成都市农业科技英才培育项目'
    },
    component: () => import('../views/132.vue')
  },
  {
    path: '/133',
    name: '133',
    meta: {
      title: '成都市农业科技专家服务团'
    },
    component: () => import('../views/133.vue')
  },
  {
    path: '/134',
    name: '134',
    meta: {
      title: '成都市支持优秀人才返乡入乡创办领办农民专业合作社和家庭农场'
    },
    component: () => import('../views/134.vue')
  },
  {
    path: '/135',
    name: '135',
    meta: {
      title: '成都市农业职业经理人'
    },
    component: () => import('../views/135.vue')
  },
  {
    path: '/136',
    name: '136',
    meta: {
      title: '成都市深化农业职业经理人队伍建设的十条措施'
    },
    component: () => import('../views/136.vue')
  },
  {
    path: '/137',
    name: '137',
    meta: {
      title: '成华区人才培育平台建设补贴'
    },
    component: () => import('../views/137.vue')
  },
  {
    path: '/138',
    name: '138',
    meta: {
      title: '成华区“东骄英才”人才项目'
    },
    component: () => import('../views/138.vue')
  },
  {
    path: '/139',
    name: '139',
    meta: {
      title: '成华区“东骄俊杰”人才项目'
    },
    component: () => import('../views/139.vue')
  },
  {
    path: '/140',
    name: '140',
    meta: {
      title: '成华区“东骄伯乐奖”引才奖励'
    },
    component: () => import('../views/140.vue')
  },
  {
    path: '/141',
    name: '141',
    meta: {
      title: '成华区“产业教授”项目'
    },
    component: () => import('../views/141.vue')
  },
  {
    path: '/142',
    name: '142',
    meta: {
      title: '产业急需紧缺应届硕士研究生生活'
    },
    component: () => import('../views/142.vue')
  },
  {
    path: '/143',
    name: '143',
    meta: {
      title: '产业急需紧缺技术人才引育奖励'
    },
    component: () => import('../views/143.vue')
  },
  {
    path: '/144',
    name: '144',
    meta: {
      title: '引进培育技能人才(平台)和专业技术政策解读'
    },
    component: () => import('../views/144.vue')
  },
  {
    path: '/145',
    name: '145',
    meta: {
      title: '蒲江县“乡村振兴优秀人才(团队)”'
    },
    component: () => import('../views/145.vue')
  },
  {
    path: '/146',
    name: '146',
    meta: {
      title: '蒲江县“名师工作室”政策解读'
    },
    component: () => import('../views/146.vue')
  },
  {
    path: '/147',
    name: '147',
    meta: {
      title: '蒲江县“电子商务杰出人才”'
    },
    component: () => import('../views/147.vue')
  },
  {
    path: '/148',
    name: '148',
    meta: {
      title: '成蒲铁路人才通勤10元票价优惠政策解读'
    },
    component: () => import('../views/148.vue')
  },
  {
    path: '/149',
    name: '149',
    meta: {
      title: '青羊区获创新创业大赛奖项补贴'
    },
    component: () => import('../views/149.vue')
  },
  {
    path: '/150',
    name: '150',
    meta: {
      title: '青羊区青年人才驿站15天免费入住服务'
    },
    component: () => import('../views/150.vue')
  },
  {
    path: '/151',
    name: '151',
    meta: {
      title: '青羊区硕士以上学历应届毕业生生活补贴政策解读'
    },
    component: () => import('../views/151.vue')
  },
  {
    path: '/152',
    name: '152',
    meta: {
      title: '青羊区应届毕业生一次性租房补贴'
    },
    component: () => import('../views/152.vue')
  },
]

const routes = baseRoutes.concat(jinjiang, chongzhou, wuhou, dayi,qingyang,qingbaijiang)

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})
router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
})
export default router
